// extracted by mini-css-extract-plugin
module.exports = {"nutritionStyle":"_1_O_uKSUHWMtPYKmoeLUX3"};